import { Builder } from '@builder.io/react'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import defaultBackgroundImage from '../../../images/Wavybackground.svg'
import testImg from '../../../images/recipes/braised-beef-raw.jpeg'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum TextAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

interface Props {
  backgroundColor: string
  headingText: string
  headingTextColor: string
  subTextEnabled: boolean
  subText: string
  subTextColor: string
  buttonOne: LinkButtonProp
  textAlignment: TextAlignment
  headingType: HeadingType
  headingClass: HeadingClass
  button: boolean
  backgroundImage: File
}

const CTAThree = ({
  backgroundColor,
  headingText,
  headingTextColor,
  subTextEnabled,
  subText,
  subTextColor,
  buttonOne,
  textAlignment,
  headingType,
  headingClass,
  button,
  backgroundImage
}: Props) => {
  const getSubText = () => {
    if (!subTextEnabled) return null

    return (
      <p className="mt-4 text-lg leading-6 text-indigo-200" style={{ color: subTextColor }}>
        {subText}
      </p>
    )
  }

  return (
    <div
      className="bg-indigo-700"
      style={{
        backgroundColor: backgroundColor,
        backgroundImage: backgroundImage ? `url(${backgroundImage ?? ''})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
        // backgroundPosition: 'right bottom'
      }}
    >
      <div className="mx-auto py-4 px-4 sm:px-6 lg:px-8" style={{ textAlign: textAlignment }}>
        <CustomHeading
          classList="font-bold text-white tracking-tight"
          headingClass={headingClass}
          headingType={headingType}
          color={headingTextColor}
        >
          {headingText}
        </CustomHeading>
        {getSubText()}
        {button && buttonOne && (
          <LinkButton
            buttonColor={buttonOne.buttonColor}
            buttonText={`${buttonOne.buttonText} `}
            buttonTextColor={buttonOne.buttonTextColor}
            loggedInButtonText={buttonOne.loggedInButtonText}
            buttonUrl={buttonOne.buttonUrl}
            isLink={buttonOne.isLink}
            classList={
              'mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-indigo-600 bg-white hover:bg-indigo-50 md:w-auto'
            }
          />
        )}
      </div>
    </div>
  )
}

export default CTAThree

Builder.registerComponent(CTAThree, {
  name: 'CTAThree',
  inputs: [
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Boost your productivity. Start using workflow today.'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'subTextEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'subText',
      type: 'text',
      defaultValue:
        'Varius facilisi mauris sed sit. Non sed et duis dui leo, vulputate id malesuada non. Cras aliquet purus dui laoreet diam sed lacus, fames.'
    },
    {
      name: 'subTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOne'
    },
    {
      name: 'button',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: defaultBackgroundImage
    }
  ]
})
